import _taggedTemplateLiteral from '../../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled, css } from '@mgmresorts/wcl-styled';
import { rgba } from '../../../../../node_modules/polished/dist/polished.esm.es.js';

var _templateObject, _templateObject2, _templateObject3;
var StyledSelectListItem = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding: 14px 12px;\n  color: ", ";\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  ", "\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n  }\n  ", "\n"])), function (p) {
  return p.theme.colors.black;
}, function (p) {
  return p.active && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "])), p.theme.colors["interface"], rgba(p.theme.colors["interface"], 0.08));
}, function (p) {
  return p.selected && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      background-color: rgba(0, 0, 0, 0.12);\n    "])));
});

export { StyledSelectListItem };
